mutation DeleteTargetAudience($id: ID!) {
  deleteTargetAudience(input: { id: $id }) {
    success
  }
}
